import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgPaymentSkeletonDesktop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 636 244"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={636} height={244} rx={4} fill="#fff" />
    <path fill="#fff" d="M8 8h620v116H8z" />
    <rect x={16.5} y={19.5} width={15} height={15} rx={7.5} stroke="#E6E6E6" />
    <path
      d="M38 27h252.5M18 42h602M18 58h602M18 74h602M18 90h602M18 106h537"
      stroke="#E6E6E6"
    />
    <path fill="#fff" d="M8 124h620v118H8z" />
    <rect x={16.5} y={135.5} width={15} height={15} rx={7.5} stroke="#E6E6E6" />
    <path
      d="M38 143h252.5M18 158h602M18 174h602M18 190h602M18 206h602M18 222h537"
      stroke="#E6E6E6"
    />
  </svg>
);
const Memo = memo(SvgPaymentSkeletonDesktop);
export default Memo;
